module.exports = __webpack_public_path__ + "static/header-layer-2-71c4895c1ca1fd8afe6dc03048cddf3b.png";